import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const UpdateAccountModalAccountFragmentDoc = gql`
  fragment UpdateAccountModalAccount on Account {
    id
    name
    code
    description
    children {
      totalCount
    }
    parent {
      id
    }
  }
` as unknown as DocumentNode<Types.UpdateAccountModalAccountFragment, unknown>
